import { createAction } from "../fns/createAction";
import { fns } from "@holta/lib";
import { libTypes } from "@holta/lib";

export const setCustomers = createAction("SET_CUSTOMERS", (newState, customers: libTypes.Customer[]) => {
    newState.customers = fns.shared.sortByString(customers, 'name', 'ASC');
});
